import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { INSURANCE_TYPES } from "@/lib/constants";
import { ArrowRight } from "lucide-react";

export default function InsuranceTypes() {
  return (
    <section
      id="coverage"
      data-testid="insurance-types-section"
      className="py-24 sm:py-32 bg-pp-cream relative grain-overlay"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative">
        <div className="max-w-3xl mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-pp-forest">
            Coverage options
          </span>
          <h2 className="mt-4 font-serif font-medium text-4xl sm:text-5xl lg:text-6xl tracking-tight text-pp-forest-deep leading-[1.1]">
            Find the policy that fits your{" "}
            <span className="italic text-pp-terracotta">life chapter.</span>
          </h2>
          <p className="mt-6 text-lg text-pp-text-secondary leading-relaxed">
            Every family is different. Below are the five core types of life
            insurance Darryl helps clients navigate every day.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {INSURANCE_TYPES.map((p, i) => (
            <article
              key={p.id}
              data-testid={`insurance-card-${p.id}`}
              className="group bg-white border border-pp-border-subtle rounded-2xl p-8 lg:p-10 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(26,46,38,0.08)] flex flex-col"
            >
              <div className="text-pp-terracotta text-sm font-medium mb-3">
                0{i + 1}
              </div>
              <h3 className="font-serif text-3xl text-pp-forest-deep mb-3 leading-tight">
                {p.name}
              </h3>
              <p className="text-pp-text-secondary mb-6">{p.short}</p>

              <p className="text-sm text-pp-text-secondary leading-relaxed mb-6">
                {p.long}
              </p>

              <ul className="space-y-2 mb-8">
                {p.highlights.map((h) => (
                  <li
                    key={h}
                    className="flex items-start gap-2 text-sm text-pp-forest-deep"
                  >
                    <span className="mt-2 w-1 h-1 rounded-full bg-pp-terracotta flex-shrink-0" />
                    {h}
                  </li>
                ))}
              </ul>

              <div className="mt-auto pt-4 border-t border-pp-border-subtle">
                <div className="text-xs uppercase tracking-wider text-pp-text-secondary mb-3">
                  Best for
                </div>
                <p className="text-sm text-pp-forest-deep mb-5">{p.bestFor}</p>
                <Link to={`/quote?type=${p.id}`}>
                  <button
                    data-testid={`insurance-card-cta-${p.id}`}
                    className="inline-flex items-center gap-2 text-pp-forest font-medium text-sm group-hover:gap-3 transition-all"
                  >
                    Quote {p.name}{" "}
                    <ArrowRight className="w-4 h-4 stroke-[1.5]" />
                  </button>
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-16 text-center">
          <Link to="/quote">
            <Button
              data-testid="coverage-section-cta"
              className="bg-pp-forest hover:bg-pp-forest-dark text-white rounded-full px-10 py-6 text-base"
            >
              Compare all options
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
